import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('packagePallets', packagePallets);

function packagePallets($translate) {
  return function packagePalletsFilter(packageList) {
    let sum = 0;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          sum += pkg.items.reduce((acc, item) => {
            if (item.pallets) {
              acc += (item.pallets || 0);
              // acc += (item.pallets * (item.count || 1));
            }
            return acc;
          }, 0);
        }
      });
    }

    sum =  Number.isInteger(sum) ? sum : Number(sum.toFixed(2));
    return $translate.instant(sum === 1 ? 'X_PALLET' : 'X_PALLETS', {sum: sum});
  }
}
